import Input from "../../core/Input.tsx";
import { IconLock } from "@tabler/icons-react";
import { ErrorMessage } from "@hookform/error-message";
import {
  TEXT_NEW_PASSWORD_REQUIRED,
  TEXT_PASSWORD_REQUIRED,
} from "../../../const/text.ts";
import { useFormContext } from "react-hook-form";
import { PASSWORD_VALIDATOR } from "../../../const/validators.ts";

const PasswordInput = ({
  autoComplete,
  requiredText = autoComplete === "current-password"
    ? TEXT_PASSWORD_REQUIRED
    : TEXT_NEW_PASSWORD_REQUIRED,
}: {
  requiredText?: string;
  autoComplete: "new-password" | "current-password";
}) => {
  const {
    register,
    formState: { errors, touchedFields },
  } = useFormContext();
  return (
    <Input
      input="input"
      label={"Passwort"}
      icon={<IconLock stroke={2} />}
      validatorHint={<ErrorMessage errors={errors} name="password" />}
      isTouched={!!touchedFields.password}
      isError={!!errors.password}
    >
      <input
        type="password"
        autoComplete={autoComplete}
        placeholder="Passwort"
        {...register("password", {
          required: requiredText,
          validate: PASSWORD_VALIDATOR,
        })}
      />
    </Input>
  );
};
export default PasswordInput;
